import React, { useState, useEffect, useContext } from "react";

import BannerEcommerce from "../../assets/showcases/ecommerce-banner.png";
import BannerRestaurant from "../../assets/showcases/restaurant-banner.png";

import {
	Avatar,
	Box,
	Button,
	Typography,
	Grid,
	IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Product1 from "../../assets/showcases/ecommerce/product1.jpg";
import Product2 from "../../assets/showcases/ecommerce/product2.jpg";
import Product3 from "../../assets/showcases/ecommerce/product3.jpg";
import Product4 from "../../assets/showcases/ecommerce/product4.jpg";
import Product5 from "../../assets/showcases/ecommerce/product5.jpg";
import Product6 from "../../assets/showcases/ecommerce/product6.jpg";

import Product10 from "../../assets/showcases/ecommerce/product10.jpg";
import Product11 from "../../assets/showcases/ecommerce/product11.jpg";
import Product12 from "../../assets/showcases/ecommerce/product12.jpg";
import Product13 from "../../assets/showcases/ecommerce/product13.jpg";
import Product14 from "../../assets/showcases/ecommerce/product14.jpg";
import Product15 from "../../assets/showcases/ecommerce/product15.jpg";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";

import ProductCategories1 from "../../assets/showcases/ecommerce/categories1.jpg";
import ProductCategories2 from "../../assets/showcases/ecommerce/categories2.jpg";
import ProductCategories3 from "../../assets/showcases/ecommerce/categories3.jpg";
import ProductCategories4 from "../../assets/showcases/ecommerce/categories4.jpg";
import ProductCategories5 from "../../assets/showcases/ecommerce/categories5.jpg";
import ProductCategories6 from "../../assets/showcases/ecommerce/categories6.jpg";

import { useSwipeable } from "react-swipeable";
import { CreatorContext } from "../../context/CreatorContext";
import { FavoriteBorderOutlined } from "@mui/icons-material";
import fontIcons from "../../assets/font-glyphs/icons.json";
import { SearchOutline } from "react-ionicons";
import { UserContext } from "../../context/UserContext";

const ShowcaseLayoutEcommerce = ({
	sector,
	layoutType,
	showBanner,
	showSearch,
	homeProductType,
	homeListType,
	homeShowSearch,
	homeShowStickyHeader,
	homeShowBigCarrousel,
	homeShowBigOverlayCarrousel,
	homeShowBanners,
	homeShowPadding,
	homeProductBackgroundColor,
	homeCategory,
	homeShowNews,
	homeShowFeatured,
	homeNewStyle,
	homeFeatureStyle,
	searchBackgroundColor,
	searchTextColor,
	showSearchIcon,
	searchContainerBackgroundColor,
	homeShowCategoriesGrid,
}) => {
	const { t } = useTranslation();
	const [content, setContent] = useState(null);
	const [currentIndex, setCurrentIndex] = useState(0);

	const { user } = useContext(UserContext);
	const [selectedCategory, setSelectedCategory] = useState(
		user?.app?.appSubtype === "Ecommerce"
			? t("homeCategories.sweaters")
			: t("menuCategories.classicPizzas")
	);

	const { creator } = useContext(CreatorContext);

	const Icon = React.memo(({ family, name, color, ...props }) => (
		<span
			style={{
				fontSize: 10,
				fontFamily:
					family === "FontAwesome5"
						? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
						: family,
				color: color ? color : "#000000",
			}}
			{...props}
		>
			{String.fromCodePoint(fontIcons[family][name])}
		</span>
	));

	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "ecommerce":
					return {
						banner: BannerEcommerce,
						products: [
							{
								name: t("homeProducts.blueSweater"),
								price: "€18.99",
								image: Product1,
							},
							{
								name: t("homeProducts.pinkSweater"),
								price: "€17.99",
								image: Product2,
							},
							{
								name: t("homeProducts.oversizePinkSweater"),
								price: "€25.99",
								image: Product3,
							},
							{
								name: t("homeProducts.oversizePinkSweater"),
								price: "€20.99",
								image: Product4,
							},
							{
								name: t("homeProducts.oversizePinkSweater"),
								price: "€17.99",
								image: Product5,
							},
							{
								name: t("homeProducts.oversizePinkSweater"),
								price: "€22.99",
								image: Product6,
							},
						],
						categories: [
							{
								name: t("homeCategories.sweaters"),
								image: ProductCategories1,
							},
							{
								name: t("homeCategories.shirts"),
								image: ProductCategories2,
							},
							{
								name: t("homeCategories.handbags"),
								image: ProductCategories3,
							},
							{
								name: t("homeCategories.skirts"),
								image: ProductCategories4,
							},
							{
								name: t("homeCategories.blazers"),
								image: ProductCategories5,
							},
							{
								name: t("homeCategories.jeans"),
								image: ProductCategories6,
							},
						],
						featuredProducts: [
							{
								name: t("homeProducts.grayCheckedBlazer"),
								price: "$49.99",
								image: Product13,
							},
							{
								name: t("homeProducts.coralBlazer"),
								price: "$21.99",
								image: Product14,
							},
							{
								name: t("homeProducts.pinkCheckedBlazer"),
								price: "$49.99",
								image: Product15,
							},
						],
						newsProducts: [
							{
								name: t("homeProducts.snakeSkinPurse"),
								price: "$49.99",
								image: Product10,
							},
							{
								name: t("homeProducts.miniGoldenBag"),
								price: "$35.99",
								image: Product11,
							},
							{
								name: t("homeProducts.pinkPurse"),
								price: "$29.99",
								image: Product12,
							},
						],
					};

				case "restaurant":
					return {
						banner: BannerRestaurant,
						products: [
							{
								name: t("menuItems.pepperoniPizza"),
								price: "€8.00",
								image: ProductRestaurant1,
							},
							{
								name: t("menuItems.cheesePizza"),
								price: "€8.00",
								image: ProductRestaurant2,
							},
							{
								name: t("menuItems.vegetarianPizza"),
								price: "€9.50",
								image: ProductRestaurant3,
							},
							{
								name: t("menuItems.hamPizza"),
								price: "€8.00",
								image: ProductRestaurant4,
							},
						],
						categories: [
							{
								name: t("menuCategories.classicPizzas"),
								image: ProductRestaurant1,
							},
							{
								name: t("menuCategories.gourmetPizzas"),
								image: ProductRestaurant2,
							},
							{
								name: t("menuCategories.specialPizzas"),
								image: ProductRestaurant5,
							},
							{
								name: t("menuCategories.others"),
								image: ProductRestaurant2,
							},
						],
						featuredProducts: [
							{
								name: t("menuItems.supremePizza"),
								price: "€9.00",
								image: ProductRestaurant5,
							},
							{
								name: t("menuItems.pepperoniPizza"),
								price: "€8.00",
								image: ProductRestaurant1,
							},
							{
								name: t("menuItems.specialPizza"),
								price: "€10.00",
								image: ProductRestaurant3,
							},
						],
						newsProducts: [
							{
								name: t("menuItems.onionSausagePizza"),
								price: "€9.00",
								image: ProductRestaurant6,
							},
							{
								name: t("menuItems.margarita"),
								price: "€7.00",
								image: ProductRestaurant3,
							},
							{
								name: t("menuItems.specialPizza"),
								price: "€10.00",
								image: ProductRestaurant3,
							},
						],
					};

				default:
					return {};
			}
		};

		setContent(loadContent());
	}, [sector, t]);

	const handlers = useSwipeable({
		onSwipedLeft: () => handleNext(),
		onSwipedRight: () => handlePrev(),
		preventScrollOnSwipe: true,
		trackMouse: true,
	});

	const handleNext = () => {
		if (content && content.categories) {
			setCurrentIndex(
				(prevIndex) => (prevIndex + 1) % content.categories.length
			);
		}
	};

	const handlePrev = () => {
		if (content && content.categories) {
			setCurrentIndex((prevIndex) =>
				prevIndex === 0 ? content.categories.length - 1 : prevIndex - 1
			);
		}
	};

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFF";
	};

	return (
		<Box
			sx={{
				position: "relative",
				"& *:not(span)": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			{homeShowSearch && (
				<Box
					sx={{
						padding: "6px",
						backgroundColor: searchContainerBackgroundColor,
					}}
				>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							padding: "0px 6px",
							height: "18px",
							borderRadius: "4px",
							backgroundColor: searchBackgroundColor,
							color: searchTextColor,
							width: "100%",
						}}
					>
						{showSearchIcon && (
							<SearchOutline
								color={searchTextColor}
								style={{
									height: "auto",
									marginRight: "8px",
									opacity: 0.6,
								}}
								width="10px"
							/>
						)}
						<Typography variant="body2" sx={{ fontSize: "8px", opacity: 0.9 }}>
							{t("search.search")}
						</Typography>
					</Box>
				</Box>
			)}

			{showBanner && content && content.banner && (
				<img
					alt={t("homeServices.bannerAlt")}
					src={content.banner}
					style={{ width: "100%" }}
					draggable={false}
				/>
			)}

			{homeShowFeatured && content && content.featuredProducts && (
				<Box sx={{ padding: 1, paddingTop: 0 }}>
					<Typography
						variant="body2"
						sx={{
							fontSize: 7,
							marginBottom: 0.5,
							fontFamily: creator.fontFamilyCap + "!important",
						}}
					>
						{t("homeServices.featured")}
					</Typography>
					<Box
						sx={{
							display: "flex",
							overflowX: "auto",
							gap: homeFeatureStyle === "featureStyle2" ? 3 : 1,
							marginLeft: homeFeatureStyle === "featureStyle2" ? 2 : 0,
						}}
					>
						{content.featuredProducts.map((service, index) => (
							<Box
								key={index}
								sx={{
									display: "flex",
									flexDirection: "column",
									position: "relative",
									alignItems:
										homeFeatureStyle === "featureStyle2"
											? "center"
											: "flex-start",
								}}
							>
								<img
									src={service.image}
									alt={service.name}
									style={{
										width: homeFeatureStyle === "featureStyle2" ? 50 : 70,
										height:
											homeFeatureStyle === "featureStyle2"
												? 50
												: homeFeatureStyle === "featureStyle3"
												? 100
												: 70,
										objectFit: "cover",
										borderRadius: homeFeatureStyle === "featureStyle2" ? 30 : 0,
									}}
								/>
								<Box
									sx={{
										position:
											homeFeatureStyle === "featureStyle4"
												? "absolute"
												: "relative",
										display: "flex",
										flexDirection: "column",
										justifyContent:
											homeFeatureStyle === "featureStyle4"
												? "center"
												: "inherit",
										alignItems:
											homeFeatureStyle === "featureStyle4"
												? "center"
												: "inherit",
										backgroundColor:
											homeFeatureStyle === "featureStyle4"
												? "rgba(0, 0, 0, 0.6)"
												: "none",
										color:
											homeFeatureStyle === "featureStyle4"
												? "#ffffff"
												: "inherit",
										top: 0,
										left: 0,
										right: 0,
										bottom: 0,
									}}
								>
									<Typography
										variant="body2"
										sx={{
											textAlign:
												homeFeatureStyle === "featureStyle2"
													? "center"
													: "left",
											fontSize: 7,
											marginTop: 0.5,
											whiteSpace: "nowrap", // Mantiene el texto en una línea
											overflow: "hidden", // Oculta el desbordamiento
											textOverflow: "ellipsis", // Añade "..." al final si el texto es demasiado largo
											maxWidth: homeFeatureStyle === "featureStyle2" ? 70 : 70,
										}}
									>
										{service.name}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontWeight: "bold",
											textAlign:
												homeFeatureStyle === "featureStyle2"
													? "center"
													: "left",
											fontSize: 7,
										}}
									>
										{service.price}
									</Typography>
								</Box>
							</Box>
						))}
					</Box>
				</Box>
			)}

			{homeShowNews && content && content.newsProducts && (
				<Box sx={{ padding: 1, paddingTop: 0 }}>
					<Typography variant="body2" sx={{ fontSize: 7, marginBottonm: 0.5 }}>
						{t("homeServices.news")}
					</Typography>
					<Box
						sx={{
							display: "flex",
							gap: homeNewStyle === "newStyle2" ? 3 : 1,
							marginLeft: homeNewStyle === "newStyle2" ? 2 : 0,
							overflowX: "auto",
						}}
					>
						{content.newsProducts.map((service, index) => (
							<Box
								key={index}
								sx={{
									display: "flex",
									flexDirection: "column",
									position: "relative",
									alignItems:
										homeNewStyle === "newStyle2" ? "center" : "flex-start",
								}}
							>
								<img
									src={service.image}
									alt={service.name}
									style={{
										width: homeNewStyle === "newStyle2" ? 50 : 70,
										height:
											homeNewStyle === "newStyle2"
												? 50
												: homeNewStyle === "newStyle3"
												? 100
												: 70,
										objectFit: "cover",
										borderRadius: homeNewStyle === "newStyle2" ? 30 : 0,
									}}
								/>
								<Box
									sx={{
										position:
											homeNewStyle === "newStyle4" ? "absolute" : "relative",
										display: "flex",
										flexDirection: "column",
										justifyContent:
											homeNewStyle === "newStyle4" ? "center" : "inherit",
										alignItems:
											homeNewStyle === "newStyle4" ? "center" : "inherit",
										backgroundColor:
											homeNewStyle === "newStyle4"
												? "rgba(0, 0, 0, 0.6)"
												: "none",
										color: homeNewStyle === "newStyle4" ? "#ffffff" : "inherit",
										top: 0,
										left: 0,
										right: 0,
										bottom: 0,
									}}
								>
									<Typography
										variant="body2"
										sx={{
											textAlign:
												homeFeatureStyle === "featureStyle2"
													? "center"
													: "left",
											fontSize: 7,
											marginTop: 0.5,
											whiteSpace: "nowrap", // Mantiene el texto en una línea
											overflow: "hidden", // Oculta el desbordamiento
											textOverflow: "ellipsis", // Añade "..." al final si el texto es demasiado largo
											maxWidth: homeFeatureStyle === "featureStyle2" ? 70 : 70,
										}}
									>
										{service.name}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontWeight: "bold",
											textAlign:
												homeNewStyle === "featureStyle2" ? "center" : "left",
											fontSize: 7,
										}}
									>
										{service.price}
									</Typography>
								</Box>
							</Box>
						))}
					</Box>
				</Box>
			)}

			{homeShowCategoriesGrid && (
				<Box sx={{ paddingLeft: 1, paddingRight: 1, paddingBottom: 1 }}>
					<Grid container spacing={1}>
						{content &&
							content.categories.map((category, index) => (
								<Grid item xs={6} key={index}>
									<Box sx={{}}>
										<Box
											sx={{
												position: "relative",
												overflow: "hidden",
											}}
										>
											<img
												src={category.image}
												alt={category.name}
												style={{
													width: "100%",
													objectFit: "cover",
													display: "block",
													height: 40,
												}}
											/>

											<Box
												sx={{
													position: "absolute",
													bottom: 0,
													left: 0,
													right: 0,
													top: 0,
													backgroundColor: "rgba(0, 0, 0, 0.6)",
													color: "#ffffff",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													justifyContent: "center",
													textAlign: "center",
												}}
											>
												<Typography variant="body1" sx={{ fontSize: 8 }}>
													{category.name}
												</Typography>
											</Box>
										</Box>
									</Box>
								</Grid>
							))}
					</Grid>
				</Box>
			)}
			{homeProductType === "homeProduct1" && !homeShowStickyHeader ? (
				homeShowBigCarrousel ? (
					<Box sx={{ padding: homeShowPadding ? 1 : 0 }}>
						<Box
							{...handlers}
							sx={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								width: "100%",
								maxWidth: 360, // Limita el ancho máximo del carrusel
								height: showBanner ? 230 : "100%", // Ajusta la altura del carrusel
								overflow: "hidden",
								marginTop: homeShowPadding ? "-7px" : "0px",
							}}
						>
							<Box
								sx={{
									display: "flex",
									transition: "transform 0.5s ease",
									transform: `translateX(-${currentIndex * 100}%)`,
									width: `${200 * 100}%`,
								}}
							>
								{content &&
									content.categories.map((category, index) => (
										<Box
											key={index}
											sx={{
												flex: "0 0 100%",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												overflow: "hidden",
											}}
										>
											<img
												src={category.image}
												alt={category.name}
												style={{
													width: 200,
													height: showBanner ? 160 : 300,
													objectFit: "cover",
												}}
											/>
											<Typography
												variant="body1"
												sx={{
													fontWeight: "bold",
													fontSize: 14,
													textAlign: "center",
													marginTop: 1,
												}}
											>
												{category.name}
											</Typography>
										</Box>
									))}
							</Box>
							{/* Indicador de paginación */}
							<Box
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginTop: 1,
								}}
							>
								{content &&
									content.categories.map((_, index) => (
										<Box
											key={index}
											sx={{
												width: 3,
												height: 3,
												borderRadius: "50%",
												backgroundColor:
													index === currentIndex ? "#000000" : "#ddd",
												marginX: 0.5,
											}}
										/>
									))}
							</Box>
						</Box>
					</Box>
				) : (
					homeShowBigOverlayCarrousel && (
						<Box sx={{ padding: homeShowPadding ? 1 : 0 }}>
							<Box sx={{ position: "relative" }}>
								<Box sx={{ marginTop: homeShowPadding ? "-7px" : "0px" }}>
									<img
										src={content.categories[0].image}
										alt={content.categories[0].name}
										style={{
											width: "100%",
											height: showBanner ? 200 : 350,
											objectFit: "cover",
										}}
									/>
									<Box
										sx={{
											position: "absolute",
											bottom: 32,
											left: 0,
											right: 0,
											textAlign: "center",
										}}
									>
										<Typography
											variant="body1"
											sx={{
												fontWeight: "bold",
												fontSize: 12,
												textAlign: "center",
												marginTop: 1,
											}}
										>
											{content.categories[0].name}
										</Typography>
									</Box>
								</Box>
								{/* Indicador de paginación */}
								<Box
									sx={{
										position: "absolute",
										left: 8,
										top: "50%",
										transform: "translateY(-50%)",
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 1,
									}}
								>
									{content &&
										content.categories.map((_, index) => (
											<Box
												key={index}
												sx={{
													width: 4,
													height: 4,
													borderRadius: "50%",
													backgroundColor:
														index === currentIndex ? "#000000" : "#ddd",
													marginBottom: 1,
												}}
											/>
										))}
								</Box>
							</Box>
						</Box>
					)
				)
			) : homeCategory === true ? (
				<Grid container spacing={2} sx={{ padding: 2 }}>
					{content &&
						content.categories.map((category, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",

										overflow: "hidden",
									}}
								>
									<img
										src={category.image}
										alt={category.name}
										style={{
											width: 60,
											height: 60,
											objectFit: "cover",
											borderRadius: 0,
										}}
									/>
									<Typography
										variant="body2"
										sx={{
											fontWeight: "bold",
											fontSize: 10,
											textAlign: "center",
											marginTop: 1,
										}}
									>
										{category.name}
									</Typography>
								</Box>
							</Grid>
						))}
				</Grid>
			) : (
				<>
					<Box
						sx={{
							display: "flex",
							overflowX: "auto",
							height: 20,
						}}
					>
						{content &&
							content.categories.map((category, index) => (
								<Button
									key={index}
									variant="text"
									disableRipple={true}
									disableElevation={true}
									sx={{
										height: 20,
										paddingX: 2,
										paddingRight: 0,
										paddingLeft: 1,
										minWidth: "auto",
										fontWeight:
											selectedCategory === category.name ? "bold" : "normal",
										color:
											selectedCategory === category.name
												? "text.primary"
												: "text.secondary",
										whiteSpace: "nowrap",
										textTransform: "none",
										fontSize: 8,
										"&:hover": {
											backgroundColor: "transparent",
										},
									}}
								>
									{category.name}
								</Button>
							))}
					</Box>
					<Box sx={{ flex: 1 }}>
						{(homeProductType === "homeProduct5" ||
							homeProductType === "homeProduct6") && (
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 1,
									padding: 1,
								}}
							>
								{content &&
									content.products.map((service, index) => (
										<Box
											sx={{
												display: "flex",
												flexDirection: "row",
												backgroundColor:
													homeProductType === "homeProduct6"
														? "#ffffff"
														: homeProductBackgroundColor
														? homeProductBackgroundColor
														: "#f9f9f9",
												borderRadius:
													homeProductType === "homeProduct5" ? 2 : 0,
												justifyContent: "space-between",
												width: "100%",
												padding: 1,
												borderBottom:
													homeProductType === "homeProduct5"
														? "none"
														: "1px solid #ecf0f1",
											}}
										>
											<Box
												sx={{
													display: "flex",
													flexDirection: "column",
												}}
											>
												<Typography
													variant="body1"
													sx={{
														fontWeight: "bold",
														fontSize: 8,
														color:
															homeProductType === "homeProduct5"
																? getTextColorBasedOnBackground(
																		homeProductBackgroundColor
																  )
																: "#000000",
													}}
												>
													{service.name}
												</Typography>
												<Typography
													variant="body2"
													color="text.secondary"
													sx={{
														fontSize: 8,
														color:
															homeProductType === "homeProduct5"
																? getTextColorBasedOnBackground(
																		homeProductBackgroundColor
																  )
																: "#000000",
													}}
												>
													{service.duration}
												</Typography>
											</Box>
											<Box>
												<Typography
													variant="body2"
													sx={{
														fontWeight: "bold",
														fontSize: 8,
														textAlign: "right",
														color:
															homeProductType === "homeProduct5"
																? getTextColorBasedOnBackground(
																		homeProductBackgroundColor
																  )
																: "#000000",
													}}
												>
													{service.price}
												</Typography>
											</Box>
										</Box>
									))}
							</Box>
						)}

						{homeProductType === "homeProduct1" && (
							<Grid
								container
								spacing={homeShowPadding ? 1 : 0}
								paddingLeft={homeShowPadding ? 1 : 0}
								paddingRight={homeShowPadding ? 1 : 0}
								paddingTop={homeShowPadding ? 0.5 : 0}
								paddingBottom={homeShowPadding ? 0.5 : 0}
							>
								{content &&
									content.products.map((product, index) => (
										<Grid item xs={6} key={index}>
											<img
												src={product.image}
												alt={product.name}
												style={{
													width: "100%",
													height: "auto",
													aspectRatio: "1",
													objectFit: "cover",
												}}
											/>
											<Typography
												variant="body2"
												component="div"
												sx={{
													fontSize: "8px",
													paddingLeft: homeShowPadding ? 0 : 1,
													paddingRight: homeShowPadding ? 0 : 1,
												}}
											>
												{product.name}
											</Typography>
											<Box
												display="flex"
												justifyContent="space-between"
												alignItems="center"
												sx={{
													paddingLeft: homeShowPadding ? 0 : 1,
													paddingRight: homeShowPadding ? 0 : 1,
													paddingBottom: homeShowPadding ? 0 : 1,
												}}
											>
												<Typography
													variant="body1"
													sx={{ fontSize: "8px", fontWeight: "bold" }}
												>
													{product.price}
												</Typography>
												<Icon
													family={creator.favoriteIconType}
													name={creator.favoriteIconName}
												/>
											</Box>
										</Grid>
									))}
							</Grid>
						)}

						{homeProductType === "homeProduct4" && content && (
							<Box
								sx={{
									paddingTop: homeShowPadding ? 0.5 : 0,
									paddingBottom: homeShowPadding ? 0.5 : 0,
								}}
							>
								{content.products.map((product, index) => (
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											flex: 1,
											marginBottom: 0.5,
										}}
									>
										<Avatar
											src={product.image}
											alt={product.name}
											sx={{
												width: 50,
												height: 50,
												marginRight: 2,
												marginLeft: 1,
												marginBottom: 1,
												borderRadius: "40px",
											}}
										/>
										<Box>
											<Typography
												variant="body1"
												sx={{
													fontSize: 8,
												}}
											>
												{product.name}
											</Typography>
											<Typography
												variant="body2"
												sx={{
													fontWeight: "bold",
													marginTop: "0px",
													fontSize: 8,
												}}
											>
												{product.price}
											</Typography>
										</Box>
									</Box>
								))}
							</Box>
						)}

						{homeProductType === "homeProduct2" &&
							content &&
							content.products.map((product, index) => (
								<Box
									sx={{
										display: "flex",
										alignItems: "flex-start",
										flexDirection: "column",
										flex: 1,
										padding: 0,
										paddingLeft: homeShowPadding ? 1 : 0,
										paddingRight: homeShowPadding ? 1 : 0,
										paddingTop: homeShowPadding ? 0.5 : 0,
										paddingBottom: homeShowPadding ? 0.5 : 0,
									}}
								>
									<img
										src={product.image}
										alt={product.name}
										style={{
											width: "100%",
											height: "120px",
											objectFit: "cover",
										}}
									/>
									<Box
										sx={{
											paddingBottom: 1,
											paddingLeft: homeShowPadding ? 0 : 1,
											paddingRight: homeShowPadding ? 0 : 1,
											flex: 1,
											width: "100%",
										}}
									>
										<Typography
											variant="body1"
											sx={{ fontSize: 8, textAlign: "left", marginTop: 1 }}
										>
											{product.name}
										</Typography>
										<Box
											display="flex"
											justifyContent="space-between"
											alignItems="center"
											flex={1}
										>
											<Typography
												variant="body1"
												sx={{ fontSize: "8px", fontWeight: "bold" }}
											>
												{product.price}
											</Typography>
											<Icon
												family={creator.favoriteIconType}
												name={creator.favoriteIconName}
											/>
										</Box>
									</Box>
								</Box>
							))}

						{homeProductType === "homeProduct3" &&
							content &&
							content.products.map((service, index) => (
								<Box
									sx={{
										paddingLeft: homeShowPadding ? 1 : 0,
										paddingRight: homeShowPadding ? 1 : 0,
										paddingTop: homeShowPadding ? 0.5 : 0,
										paddingBottom: homeShowPadding ? 0.5 : 0,
									}}
								>
									<Box
										sx={{
											position: "relative",
											overflow: "hidden",
										}}
									>
										<img
											src={service.image}
											alt={service.name}
											style={{
												width: "100%",
												objectFit: "cover",
												display: "block",
												height: 100,
											}}
										/>

										<Box
											sx={{
												position: "absolute",
												bottom: 0,
												left: 0,
												right: 0,
												top: 0,
												backgroundColor: "rgba(0, 0, 0, 0.6)",
												color: "#ffffff",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												justifyContent: "center",
												textAlign: "center",
											}}
										>
											<Typography variant="body1" sx={{ fontSize: 8 }}>
												{service.name}
											</Typography>
											<Typography
												variant="body2"
												sx={{ fontWeight: "bold", fontSize: 8 }}
											>
												{service.price}
											</Typography>
											<Box sx={{ position: "absolute", top: 3, right: 6 }}>
												<Icon
													family={creator.favoriteIconType}
													name={creator.favoriteIconName}
													color={"#ffffff"}
												/>
											</Box>
										</Box>
									</Box>
								</Box>
							))}
					</Box>
				</>
			)}
		</Box>
	);
};

export default ShowcaseLayoutEcommerce;
